import { Command } from 'ckeditor5';
import { ConditionState } from './State';
import { buildMarkerNameFor } from './markerName';
export const RENAME_CONDITION_REF_COMMAND = 'renameConditionRef';
/**
 * Repoints every condition on question `from` at question `to`, in a single undoable step, so a
 * rename does not leave them pointing at a ref that no longer resolves. Pass `from === to` with
 * `choiceKeys` to rename choice keys only. Returns the number rewritten.
 */
export class RenameConditionRefCommand extends Command {
    get state() {
        return this.editor.plugins.get(ConditionState);
    }
    execute(options) {
        const { from, to, choiceKeys } = options;
        const { model } = this.editor;
        const affected = this.state
            .getConditionsInDocument()
            .filter((condition) => condition.ref === from)
            .map((condition) => {
            var _a;
            const choiceKey = condition.choiceKey ? (_a = choiceKeys === null || choiceKeys === void 0 ? void 0 : choiceKeys[condition.choiceKey]) !== null && _a !== void 0 ? _a : condition.choiceKey : undefined;
            return Object.assign(Object.assign({}, condition), { newMarkerName: buildMarkerNameFor({ predicate: condition.predicate, ref: to, choiceKey }, condition.instanceId) });
        })
            .filter((condition) => condition.newMarkerName !== condition.markerName);
        if (!affected.length) {
            return 0;
        }
        affected.forEach(({ markerName }) => this.state.markRenaming(markerName));
        model.change((writer) => {
            affected.forEach(({ markerName, newMarkerName }) => {
                const marker = model.markers.get(markerName);
                if (!marker) {
                    return;
                }
                const range = marker.getRange();
                writer.removeMarker(markerName);
                writer.addMarker(newMarkerName, { range, usingOperation: true, affectsData: true });
            });
        });
        affected.forEach(({ newMarkerName }) => this.state.addCondition(newMarkerName));
        return affected.length;
    }
}
